import { useState } from "react";
import SideMenu from "../../components/admin/SideMenu";
import ResultLists from "../../components/admin/lists/ResultLists";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const AdminResults = () => {
  const [editUserId, setEditUserId] = useState<string | null>(null);
  const [isNew, setIsNew] = useState(false);
  const [selectedTab, setSelectedTab] = useState("QuartetContest");

  const { currentUser } = useCurrentUser();

  const handleEditUser = (userId: string) => {
    setEditUserId(userId);
    setIsNew(false);
  };

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          {currentUser?.judge !== true ? (
            <>
              <h3>点数一覧</h3>

              <div className="permission-error">
                このページを表示する権限がありません。
              </div>
            </>
          ) : (
            <>
              <h3>点数一覧</h3>

              {!editUserId && !isNew && (
                <div className="list-header">
                  <div className="tab">
                    <button
                      className={`quartet ${
                        selectedTab === "QuartetContest" ? "active" : ""
                      }`}
                      onClick={() => setSelectedTab("QuartetContest")}
                    >
                      Quartet Contest
                    </button>

                    <button
                      className={`chorus ${
                        selectedTab === "ChorusContest" ? "active" : ""
                      }`}
                      onClick={() => setSelectedTab("ChorusContest")}
                    >
                      Chorus Contest
                    </button>

                    <button
                      className={`evaluation ${
                        selectedTab === "EvaluationOnly" ? "active" : ""
                      }`}
                      onClick={() => setSelectedTab("EvaluationOnly")}
                    >
                      Evaluation Only
                    </button>
                  </div>
                </div>
              )}

              <ResultLists onEdit={handleEditUser} selectedTab={selectedTab} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminResults;
